__turbopack_context__.v({
  "aboveBottomBar": "Toolbar-module-scss-module__sADPHG__aboveBottomBar",
  "gift": "Toolbar-module-scss-module__sADPHG__gift",
  "goftino": "Toolbar-module-scss-module__sADPHG__goftino",
  "jiggle": "Toolbar-module-scss-module__sADPHG__jiggle",
  "slide-in": "Toolbar-module-scss-module__sADPHG__slide-in",
  "toolbar": "Toolbar-module-scss-module__sADPHG__toolbar",
  "unset": "Toolbar-module-scss-module__sADPHG__unset",
});
